import { Component, Input, Output, EventEmitter } from "@angular/core";
import { TicketWatcher } from "@app2/type-defs/ticket/ticket-types";

@Component({
    selector: "ticket-watchers-list",
    template: `
        <ul *ngIf="watchers.length"
            class="no-list-styles">
            <li *ngFor="let watcher of watchers"
                class="nice-form-display-text declutter"
                [attr.test-id]="'watcher-' + watcher.personId">
                <div class="watcher-container">
                    <div>
                        <person-name [id]="watcher.personId" test-class="ticket-watcher"></person-name>
                        (
                        <a class="link-text"
                           *dsPermissionsRequired="editPerm"
                           (click)="onEditWatcherType.emit(watcher)"
                           test-id="change-state">
                            <div class="inline-block"
                                 *ngIf="watcher.type === 'state'"
                                 [matTooltip]="'STATE_WATCHER_DESCRIPTION' | localize">
                                {{ "STATE" | localize | lowercase }}
                            </div>
                            <div class="inline-block"
                                 *ngIf="watcher.type === 'all'"
                                 [matTooltip]="'ALL_WATCHER_DESCRIPTION' | localize">
                                {{ "ALL" | localize | lowercase }}
                            </div>
                        </a>
                        <span *dsPermissionsRequired="'!'+editPerm">
                            <div class="inline-block"
                                 *ngIf="watcher.type === 'state'"
                                 [matTooltip]="'STATE_WATCHER_DESCRIPTION' | localize">
                                 {{ "STATE" | localize | lowercase }}
                            </div>
                            <div class="inline-block"
                                 *ngIf="watcher.type === 'all'"
                                 [matTooltip]="'ALL_WATCHER_DESCRIPTION' | localize">
                                 {{ "ALL" | localize | lowercase }}
                            </div>
                        </span>
                        )
                    </div>
                    <button type="button"
                            class="link inline-delete show-on-hover watcher-delete-button"
                            *dsPermissionsRequired="editPerm"
                            (click)="onDeleteWatcher.emit(watcher.personId)"
                            test-id="delete-watcher">
                        <i class="ion-trash-a alert"></i>
                    </button>
                </div>
            </li>
        </ul>
    `,
    styles: [`
      .watcher-container {
        display: flex;
        justify-content: space-between;
      }
      .watcher-delete-button {
        padding-bottom: 0.1rem;
        padding-top: 0.1rem;
      }
    `],
})
export class TicketWatchersListComponent {
    @Input() editPerm: string;
    @Input() watchers: TicketWatcher[] = [];

    // eslint-disable-next-line @angular-eslint/no-output-on-prefix
    @Output() onEditWatcherType = new EventEmitter<TicketWatcher>();
    // eslint-disable-next-line @angular-eslint/no-output-on-prefix
    @Output() onDeleteWatcher = new EventEmitter<uuid>();
}
